import React, { useEffect, useState } from 'react';
import './machine_css.css';
import CardBrands from '../Icons/Card_brands.png';
import PaymentInstructions from '../Icons/paymentTerminal.svg';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { useHistory } from 'react-router';
import localRequest from '../services/LocalServer/localRequest';

export default function PaymentPrompt(props) {
  let history = useHistory();
  const { t } = useTranslation();
  const machineID = props.id;
  const [message, setMessage] = useState(t('Tap, insert, or swipe your card.'));
  const [one, setone] = useState(true);
  const [allowback, setallowback] = useState(true);

  useEffect(() => {
    // payment status request
    var interval = setInterval(() => fetchAPI(), 500);

    async function fetchAPI() {
      await axios
        .get(`${process.env.REACT_APP_LOCAL_API}/paymentStatus`, {
          headers: {
            'X-CompanyID': 'magex',
            'X-Token': process.env.REACT_APP_X_TOKEN,
          },
        })
        .then(async (status) => {
          if (status.data.status_message) {
            setMessage(status.data.status_message);
          }
          if (status.data.status && status.data.status !== '') {
            setallowback(false);
          }
          if (status.data.status === 'SUCCESS') {
            // clearInterval(outInterval);
            clearInterval(interval);
            localStorage.setItem('payment_type', 'Credit');
            history.push(`/machineUI/product-dispense/${machineID}`);
          } else if (status.data.status === 'PAYMENTERROR') {
            clearInterval(interval);
            setMessage('Payment error, back to previous page');
            setTimeout(() => {
              history.goBack();
            }, 3000);
          }
          const dataDate = new Date(status.data.date);
          const nowDate = new Date();

          const dif = nowDate.getTime() - dataDate.getTime();
          // if (dif < 30000) {
          //   console.log('lowlowlow');
          //   props.setIdle(props.idle ? false : true);
          // }
          if (dif < 30000) {
            props.setIdle(dif);
          }
        });
    }

    return () => {
      clearInterval(interval);
      // clearInterval(outInterval);
    };

    // history.push(`/machineUI/product-dispense/${machineID}`);
  }, []);

  const cancelButton = async () => {
    if (one && allowback) {
      await localRequest({
        method: 'post',
        url: `${process.env.REACT_APP_LOCAL_API}/paymentUpdate`,
        data: {
          status: 'CANCEL',
        },
      }).then((res) => {
        setone(false);
        setTimeout(() => {
          history.goBack();
        }, 3000);
      });
    }
  };

  // function printMessage() {
  //   if (status == 'FAIL') {
  //     return (
  //       <div
  //         style={{
  //           flexDirection: 'column',
  //           alignItems: 'center',
  //         }}
  //         className="d-flex justify-content-center mb-5"
  //       >
  //         <span className="cat-title red">{t(`Oops, Payment Error! `)}</span>
  //         <span className="cat-title red">{t(`Try again or a different card.`)}</span>
  //       </div>
  //     );
  //   } else {
  //     return (
  //       <div
  //         style={{
  //           flexDirection: 'column',
  //           alignItems: 'center',
  //         }}
  //         className="d-flex justify-content-center mb-5"
  //       >
  //         <span className="cat-title">{t(`Insert, Tap or Swipe at terminal`)}</span>
  //         <span className="cat-title">{t(`to complete a payment transaction`)}</span>
  //       </div>
  //     );
  //   }
  // }

  return (
    <div className="">
      <div
        style={{
          marginBottom: '170px',
        }}
        className="row justify-content-center"
      >
        <span className="cat-title mt-5">{t(`Payment`).toUpperCase()}</span>
      </div>
      <div className="row justify-content-center mb-5">
        <img src={CardBrands} alt="card_brands" />
      </div>
      {/* {printMessage()} */}
      <span className="cat-title red">{message}</span>
      <div
        className="row justify-content-center"
        // id="clickHere"
        // onClick={() => {
        //   console.log('idle');
        //   props.setIdle(props.idle ? false : true);
        // }}
      >
        <img src={PaymentInstructions} style={{ width: '800px' }} alt="card_brands" />
      </div>
      {allowback && (
        <div className="payment-cancel-button" onClick={cancelButton}>
          {t(`CANCEL`)}
        </div>
      )}
    </div>
  );
}
